import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
export function Solutions() {
  const qualitativeResults = [{
    num: '01',
    title: 'Más consultas digitales',
    desc: 'El sitio web se convierte en fuente activa de oportunidades comerciales entrantes.'
  }, {
    num: '02',
    title: 'Mayor credibilidad percibida',
    desc: 'La empresa comunica el valor que realmente tiene desde el primer contacto digital.'
  }, {
    num: '03',
    title: 'Mejor conversión de visitas',
    desc: 'El recorrido del cliente potencial se simplifica y la tasa de contacto mejora.'
  }, {
    num: '04',
    title: 'Publicidad más efectiva',
    desc: 'La misma inversión produce más resultados cuando el sitio web convierte correctamente.'
  }];
  const plans = [{
    target: 'ICD™ 40 → 70',
    name: 'Confianza™',
    featured: false,
    question: '¿Tu sitio web actual no está a la altura de lo que tu empresa realmente vale?',
    desc: 'Para empresas que necesitan un sitio web nuevo a la altura de lo que realmente ofrecen. Construido desde cero sobre los datos del diagnóstico ICD™.',
    items: ['Sitio web estratégico nuevo']
  }, {
    target: 'ICD™ 55 → 80',
    name: 'Conversión™',
    featured: true,
    question: '¿Tu sitio web recibe visitas pero no las convierte en consultas reales?',
    desc: 'Para empresas que ya tienen un sitio web pero no está generando las consultas que debería. Lo rediseñamos basados en las brechas del ICD™.',
    items: ['Rediseño de tu sitio web actual']
  }, {
    target: 'ICD™ 75 → 95+',
    name: 'Crecimiento™',
    featured: false,
    question: '¿Tu sitio web ya convierte y quieres que trabaje de manera automatizada?',
    desc: 'Para empresas con un sitio web que ya convierte y quieren escalar con automatizaciones e integraciones estratégicas.',
    items: ['Integraciones sobre tu sitio web']
  }];
  return <section className="bg-arena py-[72px] md:py-[120px]" data-id="element-378">
      <div className="max-w-[1200px] mx-auto px-6 md:px-20" data-id="element-379">
        {/* Resultados cualitativos */}
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.4,
        ease: 'easeOut'
      }} className="mb-16 md:mb-20" data-id="element-380">
          <span className="block font-body text-[11px] uppercase font-medium text-salvia tracking-[0.15em] mb-6" data-id="element-381">
            RESULTADOS
          </span>
          <h2 className="font-display text-[32px] md:text-[48px] font-bold text-carbon max-w-[480px] mb-4" data-id="element-382">
            Cuando la brecha se reduce
          </h2>
          <p className="font-body text-[16px] md:text-[18px] text-carbon/55 mb-16 max-w-[640px]" data-id="element-383">
            Empresas con un sitio web que comunica lo que realmente valen
            reportan:
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6" data-id="element-384">
            {qualitativeResults.map((item, idx) => <div key={idx} className="bg-[#EFECE4] border border-salvia/25 rounded-[12px] p-8 hover:-translate-y-[2px] hover:border-verde/50 transition-all duration-200" data-id="element-385">
                <span className="block font-display text-[32px] font-bold text-verde/25 mb-4" data-id="element-386">
                  {item.num}
                </span>
                <p className="font-display text-[18px] font-semibold text-carbon mb-2" data-id="element-387">
                  {item.title}
                </p>
                <p className="font-body text-[14px] text-carbon/60 leading-[1.6]" data-id="element-388">
                  {item.desc}
                </p>
              </div>)}
          </div>
          <p className="font-body text-[13px] text-carbon/40 italic mt-8 text-center" data-id="element-389">
            Los resultados varían según el sector y el punto de partida. El
            ICD™ es la métrica con la que medimos y documentamos cada caso.
          </p>
        </motion.div>

        {/* Header de Soluciones */}
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.4,
        ease: 'easeOut'
      }} className="mb-12 md:mb-16" data-id="element-390">
          <span className="block font-body text-[11px] uppercase font-medium text-salvia tracking-widest mb-4" data-id="element-391">
            SITIOS WEB ESTRATÉGICOS
          </span>
          <h2 className="font-display text-[32px] md:text-[48px] font-bold text-carbon leading-[1.1] max-w-[580px] mb-4" data-id="element-392">
            El sitio web correcto depende del ICD™, no de una plantilla.
          </h2>
          <p className="font-body text-[16px] md:text-[20px] text-carbon/60 leading-[1.6] max-w-[520px]" data-id="element-393">
            Después del diagnóstico ICD™, sabemos exactamente qué necesita tu
            sitio web. No trabajamos con suposiciones de diseño.
          </p>
        </motion.div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-394">
          {plans.map((plan, idx) => <motion.div key={idx} className="bg-[#E8E5DC] border border-salvia/25 rounded-[12px] p-10 hover:-translate-y-[2px] hover:shadow-card hover:border-verde/50 transition-all duration-200 flex flex-col" initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.4,
          ease: 'easeOut',
          delay: idx * 0.1
        }} data-id="element-395">
              {plan.featured && <span className="block font-body text-[11px] uppercase font-medium text-salvia tracking-[0.12em] mb-2" data-id="element-396">
                  Más solicitado
                </span>}
              <span className="block font-body text-[12px] uppercase font-medium text-azul tracking-[0.1em] mb-3" data-id="element-397">
                {plan.target}
              </span>
              <h3 className="font-display text-[28px] md:text-[32px] font-bold text-carbon mb-3" data-id="element-398">
                {plan.name}
              </h3>
              <p className="font-body text-[16px] md:text-[17px] font-medium text-carbon mb-4" data-id="element-399">
                {plan.question}
              </p>
              <p className="font-body text-[14px] md:text-[15px] text-carbon/60 leading-[1.6] mb-6" data-id="element-400">
                {plan.desc}
              </p>

              <div className="h-px w-full bg-carbon/10 mb-6" data-id="element-401"></div>

              <div className="space-y-3 mb-8 flex-grow" data-id="element-402">
                {plan.items.map((item, i) => <div key={i} className="flex items-start gap-2" data-id="element-403">
                    <span className="text-carbon/70 mt-0.5" data-id="element-404">→</span>
                    <p className="font-body text-[14px] text-carbon/70 font-semibold" data-id="element-405">
                      {item}
                    </p>
                  </div>)}
              </div>

              <Link to="/diagnostico" className="inline-flex items-center font-display text-[14px] font-semibold text-verde group" data-id="element-406">
                Solicitar información
                <ArrowRight size={16} className="ml-1 transition-transform duration-200 group-hover:translate-x-1" data-id="element-407" />
              </Link>
            </motion.div>)}
        </div>

        <motion.div className="mt-12 md:mt-[48px] flex flex-col items-center" initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4,
        delay: 0.4
      }} data-id="element-408">
          <div className="w-full h-px bg-carbon/10 mb-12" data-id="element-409"></div>
          <p className="font-body text-[15px] text-carbon/55 text-center max-w-[480px] mb-4" data-id="element-410">
            En todos los casos comenzamos con el diagnóstico ICD™. Es lo que
            nos permite construir un sitio web que resuelva los problemas
            reales, no los que suponemos.
          </p>
          <Link to="/diagnostico" className="inline-flex items-center font-body text-[15px] font-semibold text-verde hover:translate-x-1 transition-transform duration-200" data-id="element-411">
            Solicitar el diagnóstico gratuito{' '}
            <ArrowRight size={16} className="ml-1" data-id="element-412" />
          </Link>
        </motion.div>
      </div>
    </section>;
}